import UserLogin from "../components/users/userLogin/UserLogIn";

const Login = () => {
  return (
    <div className="login-page">
      <h3>Log In</h3>
      <UserLogin />
    </div>
  );
};
export default Login;
